export default {
  props: ['hideForgotPasswordLink', 'hybridAuth'],
  data() {
    return {
      form: {
        shop_id: 0,
        email: '',
        password: '',
      },
      validation: {},
      remember: true,
      passwordType: 'password',
    };
  },
  computed: {
    id() {
      return this.coreParams.id;
    },
  },
  methods: {
    initValidation() {
      this.validation = {
        email: {
          valid: null,
          message: '',
        },
        password: {
          valid: null,
          message: '',
        },
      };
    },
    async onSubmit() {
      this.initValidation();

      this.form.shop_id = this.id;
      this.login(this.form);
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    }
  },
  created() {
    this.initValidation();

    if (this.user) {
      this.$router.push(this.i18nLink('/'));
    }
  },
};
